/** One row menu for the Visit board: each command family offers itself for the row it is opened on. */
import { VisitBrowseRow } from '@jms/model';
import { Command } from '@workbuddy/ui/model';
import { visitRemoveFromApprovalRowCommands } from './visit.remove.from.approval.command';
import { visitRetryJobCreationRowCommands } from './visit.retry.job.creation.command';

export function visitRowCommands(row: VisitBrowseRow): Command[] {

  return [...visitRetryJobCreationRowCommands(row), ...visitRemoveFromApprovalRowCommands(row)];
}
